import { type RefetchKyc, useKycProviderDetails } from '#context/provider-details-context';

/**
 * Returns a refetch that targets the source which produced the provider details:
 * the context-supplied `refetchProviderDetails` (register endpoint / fourthlineProcess)
 * when present, otherwise the acceptance `kycQueries.item()` refetch.
 *
 * The returned function has the exact same contract as the `kycQueries.item()`
 * refetch, so consumers can use it as a drop-in replacement.
 */
export function useRefetchProviderDetails(refetchAcceptance: RefetchKyc): RefetchKyc {
  const { refetchProviderDetails } = useKycProviderDetails();

  return refetchProviderDetails ?? refetchAcceptance;
}
